import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ManualPaymentSteps = ({ step, setStep }) => {
    const navigate = useNavigate();
    const [cargando, setCargando] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleEnviarComprobante = async () => {
        setCargando(true);
        setErrorMsg('');

        try {
            const reservaData = JSON.parse(sessionStorage.getItem('reserva_temp') || '{}');
            const token = localStorage.getItem('token');

            if (!reservaData.ven_fechaevento) {
                setErrorMsg('No se encontraron los datos de la ubicación o fecha del evento.');
                setCargando(false);
                return;
            }

            // Registra el evento y el local en la BD Django
            await axios.post(
                'https://backend-bambos.onrender.com/api/eventos/registrar/',
                reservaData,
                {
                    headers: {
                        'Authorization': token ? `Bearer ${token}` : '',
                        'Content-Type': 'application/json'
                    }
                }
            );

            // Limpieza de sesión temporal al completar el registro
            sessionStorage.removeItem('reserva_temp');
            setStep(3);

        } catch (error) {
            console.error("Error al registrar evento:", error);
            setErrorMsg("Hubo un error al procesar el registro en el servidor. Intenta de nuevo.");
        } finally {
            setCargando(false);
        }
    };

    if (step === 1) {
        return (
            <div className="animate__animated animate__fadeIn">
                <div className="text-center mb-4">
                    <h5 className="fw-bold text-primary border-bottom pb-2 d-inline-block">
                        PAGO CON QR (Yape/Plin)
                    </h5>
                </div>

                <div className="text-center">
                    <p className="small text-muted mb-3">Escanea con Yape o Plin de la empresa.</p>
                    
                    <div className="qr-container">
                        <img src="/BinBambo.jpg" alt="QR Empresa" className="qr-manual-image" />
                    </div>

                    <p className="small text-primary fw-bold mt-3 px-3">
                        <i className="bi bi-camera-fill me-2"></i>
                        Una vez pagado, por favor tome una captura para subirla al siguiente paso.
                    </p>
                </div>

                <div className="d-flex justify-content-between mt-5">
                    <button className="btn btn-secondary btn-sm px-4" onClick={() => navigate(-1)}>Cancelar</button>
                    <button className="btn btn-primary btn-sm px-4 shadow" onClick={() => setStep(2)}>Siguiente</button>
                </div>
            </div>
        );
    }

    if (step === 2) {
        return (
            <div className="animate__animated animate__fadeIn text-center">
                <i className="bi bi-file-earmark-arrow-up text-primary" style={{ fontSize: '3rem' }}></i>
                <h5 className="fw-bold mt-3">Comprobación de Pago</h5>
                <p className="text-muted small">Por favor, suba la captura de pantalla o foto de su comprobante.</p>
                
                <div className="border p-4 rounded bg-light d-inline-block w-100 mb-3">
                    <input type="file" className="form-control" />
                    <p className="small text-secondary mt-2 mb-0">Formatos permitidos: JPG, PNG, PDF (Máx. 5MB)</p>
                </div>

                {errorMsg && (
                    <div className="alert alert-danger small mb-3">
                        {errorMsg}
                    </div>
                )}

                <div className="mt-4">
                    <button 
                        className="btn btn-primary btn-sm px-5" 
                        onClick={handleEnviarComprobante}
                        disabled={cargando}
                    >
                        {cargando ? 'REGISTRANDO...' : 'ENVIAR COMPROBANTE'}
                    </button>
                </div>
            </div>
        );
    }

    if (step === 3) {
        return (
            <div className="animate__animated animate__fadeIn text-center py-4">
                <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '4rem' }}></i>
                <h3 className="fw-bold text-success mt-3">¡PAGO EXITOSO!</h3>
                <p className="text-muted small mt-2">Su comprobante ha sido enviado y será validado manualmente.</p>
                <div className="alert alert-info small mt-4 text-start">
                    <i className="bi bi-envelope me-2"></i>
                    Revisa tu correo. Se ha enviado una confirmación y comprobante de pago.
                </div>
                <div className="mt-5">
                    <button className="btn btn-success btn-sm px-5" onClick={() => navigate('/')}>FINALIZAR</button>
                </div>
            </div>
        );
    }
};

export default ManualPaymentSteps;